function Message({ thisstyle, children }) {
  return <div className={thisstyle}>{children}</div>;
}

export default Message;
